import React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/system';

const CustomTextField = styled(TextField)({
  '& label': {
    color: '#bdbdbd',
  },
  '& label.Mui-focused': {
    color: '#82ca9d',  // Changes label color on focus to align with theme
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#424242',  // Sets the default border color to match the dark theme
    },
    '&:hover fieldset': {
      borderColor: '#82ca9d',  // Highlight border on hover
    },
    '&.Mui-focused fieldset': {
      borderColor: '#82ca9d',  // Keeps the focus border color consistent with the dark theme
    },
    backgroundColor: '#3a3a3a',  // Dark background for inputs
    color: '#e0e0e0',  // Ensures input text is readable
    borderRadius: 4,   // Rounds the edges for a sleek look
  },
  '& .MuiInputBase-input': {
    color: '#e0e0e0',  // Text color inside input
  },
});

function OptimizationForm({
  expectedReturns,
  covMatrix,
  riskFreeRate,
  targetReturn,
  setExpectedReturns,
  setCovMatrix,
  setRiskFreeRate,
  setTargetReturn,
  handleOptimize,
  handleGAOptimize,
  loading
}) {
  return (
    <form className="container">
      <CustomTextField
        label="Expected Returns"
        variant="outlined"
        fullWidth
        value={expectedReturns}
        onChange={(e) => setExpectedReturns(e.target.value)}
        sx={{ marginBottom: 2 }}
      />
      <CustomTextField
        label="Covariance Matrix"
        variant="outlined"
        fullWidth
        value={covMatrix}
        onChange={(e) => setCovMatrix(e.target.value)}
        sx={{ marginBottom: 2 }}
      />
      <CustomTextField
        label="Risk-Free Rate"
        variant="outlined"
        fullWidth
        value={riskFreeRate}
        onChange={(e) => setRiskFreeRate(e.target.value)}
        sx={{ marginBottom: 2 }}
      />
      <CustomTextField
        label="Target Return (optional)"
        variant="outlined"
        fullWidth
        value={targetReturn}
        onChange={(e) => setTargetReturn(e.target.value)}
        sx={{ marginBottom: 2 }}
      />
      <Button variant="contained" onClick={handleOptimize} sx={{ marginRight: '10px', backgroundColor: "#388e3c" }}>
        Optimize Portfolio
      </Button>
      <Button variant="contained" color="secondary" onClick={handleGAOptimize} disabled={loading}>
        Optimize with Genetic Algorithm
      </Button>
    </form>
  );
}

export default OptimizationForm;
